module.exports = __webpack_public_path__ + "static/media/file-sharing.48813489.svg";